import React, { useState, useEffect } from "react";
import { Layout } from "../components/layout";
import { SEO } from "../components/common";
import { PatternEditor } from "../components/editor";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { AlertCircle } from "lucide-react";

export function GeneratorPage() {
  const { user, remainingMessages } = useAuth();
  const navigate = useNavigate();
  const [showLimitWarning, setShowLimitWarning] = useState(false);

  useEffect(() => {
    // Check if user is logged in and has remaining messages
    if (user) {
      if (remainingMessages !== null && remainingMessages <= 0) {
        setShowLimitWarning(true);
      }
    }
  }, [user, remainingMessages]);

  return (
    <Layout fullWidth>
      <SEO
        title="Pattern Generator | Create WordPress Block Patterns"
        description="Generate custom WordPress block patterns with AI. Create beautiful layouts for your WordPress site in seconds."
      />

      {showLimitWarning && (
        <div className="bg-amber-500/20 border border-amber-500/50 rounded-lg p-4 mb-6 mx-4">
          <div className="flex items-start">
            <AlertCircle className="h-5 w-5 text-amber-500 mt-0.5 mr-3 flex-shrink-0" />
            <div>
              <h3 className="text-amber-500 font-medium">
                Message limit reached
              </h3>
              <p className="text-gray-300 mt-1">
                You've used all your available messages. Please upgrade your
                plan to continue generating patterns.
              </p>
              <button
                className="mt-3 px-4 py-2 bg-volt-green text-volt-deep-blue rounded-lg font-medium hover:bg-volt-blue transition-colors"
                onClick={() => navigate("/pricing")}
              >
                View Pricing Plans
              </button>
            </div>
          </div>
        </div>
      )}

      <PatternEditor title="Block Pattern Generator" />
    </Layout>
  );
}
